import { observer } from 'mobx-react-lite';
import TabSwitcher from '../../components/TabSwitcher';
import Matches from './Matches';

const CHLMatches = ({ store }) => {
    const groupNames = ['R16', 'QF', 'SF', 'Final'];

    return (
        <TabSwitcher initialTabName={groupNames[0]}>
            <TabSwitcher.Tabs>
                {groupNames.length > 0 &&
                    groupNames.map((group) => {
                        return <TabSwitcher.TabPill tabName={group} key={`tabName-${group}`} />;
                    })}
            </TabSwitcher.Tabs>
            {groupNames.length > 0 &&
                groupNames.map((group) => {
                    return (
                        <TabSwitcher.TabPanel key={`tabValue-${group}`} activeWhenTabName={group}>
                            {/* group_name for api/chl/phases is similar to qualification_id for api/data/game  */}
                            <Matches store={store} qualification_id={group} />
                        </TabSwitcher.TabPanel>
                    );
                })}
        </TabSwitcher>
    );
};

export default observer(CHLMatches);
